import { gql } from '@apollo/client';

export const GET_DECISION_NODES_LIST = gql`
  query DecisionNodes($params: FindDecisionNodeListInput!) {
    decisionNodes(params: $params) {
      success
      message
      errors
      data {
        nodes {
          id
          treeKey
          nodeKey
          nodeType
          messageTemplate
          options
          inputConfig
          dynamicOptionsConfig
          terminalConfig
          contextUpdates
          parentNodeKey
          nextNode
          nextNodeOnSelect
          requiresTenant
          displayOrder
          isActive
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_DECISION_NODE = gql`
  query DecisionNode($params: FindDecisionNodeInput!) {
    decisionNode(params: $params) {
      success
      message
      errors
      data {
        id
        treeKey
        nodeKey
        nodeType
        messageTemplate
        options
        inputConfig
        dynamicOptionsConfig
        terminalConfig
        contextUpdates
        parentNodeKey
        nextNode
        nextNodeOnSelect
        requiresTenant
        displayOrder
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const GET_DECISION_NODES_BY_TREE_KEY = gql`
  query DecisionNodesByTreeKey($params: FindDecisionNodesByTreeKeyInput!) {
    decisionNodesByTreeKey(params: $params) {
      success
      message
      errors
      data {
        id
        treeKey
        nodeKey
        nodeType
        messageTemplate
        displayOrder
        isActive
      }
    }
  }
`;
